import { useRouter } from '@/routes/hooks';
import { paths } from '@/routes/paths';
import { Container } from '@mui/material';
import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BillingOrderNewEditFirstStepForm } from './billing-order-new-edit-firststep-form';
import { BillingOrderNewEditSecondStepForm } from './billing-order-new-edit-secondstep-form';
import { BillingOrderNewEditThirdstepStepForm } from './billing-order-new-edit-thirdstep-form';

type BillingOrderNewEditStepsFormProps = {
  currentOrganization?: { _id: string; name?: string };
};

export default function BillingOrderNewEditStepsForm({
  currentOrganization,
}: BillingOrderNewEditStepsFormProps) {
  const router = useRouter();
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(0);

  const steps = ['Milestones', 'Billing', 'Confirmation'];

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleCancel = () => {
    router.push(paths.management.accounts.organizations.root);
  };

  return (
    <Container maxWidth={false}>
      <Box marginTop={4} sx={{ width: '100%' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Stepper activeStep={activeStep} sx={{ width: '80%' }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{t(label)}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <Box marginTop={4}>
          {activeStep === 0 && (
            <BillingOrderNewEditFirstStepForm
              currentOrganization={currentOrganization}
              onNext={handleNext}
              onCancel={handleCancel}
            />
          )}

          {activeStep === 1 && (
            <BillingOrderNewEditSecondStepForm
              onNext={handleNext}
              onBack={handleBack}
              onCancel={handleCancel}
            />
          )}

          {activeStep === 2 && (
            <BillingOrderNewEditThirdstepStepForm onBack={handleBack} onCancel={handleCancel} />
          )}
        </Box>
      </Box>
    </Container>
  );
}
